import Model from '../Apis/ToDo'
import Controller from './Controller'

export default class ToDoController extends Controller {
  constructor() {
    super(new Model())
  }
  ///to_dos/{to_do}/toggle_status
  async ToggleStatus(id) {
   this.res= await this.model.ToggleStatus(id) ;
    return this.Poup(res);

  }
}
